import axios from '@/api/config';

const attachment = {
    addAttachment(data) {
        return axios.post(`${process.env.BASE_URL}/attachment/addAttachment`, data);
    },
    addAttachmentPhoto(data) {
        return axios.post(`${process.env.BASE_URL}/attachment/addAttachmentPhoto`, data);
    },
    deleteAttachment(data) {
        return axios.delete(`${process.env.BASE_URL}/attachment/deleteAttachment`, {data:data});
    },
    deleteAttachmentAndRelationByVideo(data) {
      return axios.delete(`${process.env.BASE_URL}/attachment/deleteAttachmentAndRelationByVideo`, {
        data: data
      });
    },
    getAttachmentList(data) {
        return axios.get(`${process.env.BASE_URL}/attachment/getAttachmentList`, { params: data });
    },
    pageList(data) {
        return axios.post(`${process.env.BASE_URL}/attachment/pageList`,  data );
    },
}
export default attachment;



// WEBPACK FOOTER //
// ./src/api/attachment.js